import { Button, Space, Table, Tooltip } from "antd";
import { ingredientOptions } from "constants/index";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function TableIngredient({
  loading,
  dataSource,
  onOpenModalUpdate,
}) {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('name'),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t('type'),
      dataIndex: "type",
      key: "type",
      render: (_) => t(ingredientOptions[_ - 1].label),
    },
    {
      title: t('vegetarian'),
      dataIndex: "isVegetarian",
      key: "isVegetarian",
      render: (_) => _ ? 'O' : 'X',
    },
    {
      title: t('core'),
      dataIndex: "core",
      key: "core",
    },
    {
      title: t('shell'),
      dataIndex: "shell",
      key: "shell",
    },
    {
      title: t('quantitySalmon'),
      dataIndex: "numSalmon",
      key: "numSalmon",
    },
    {
      title: t('quantityTuna'),
      dataIndex: "numTuna",
      key: "numTuna",
    },
    {
      title: t('action'),
      dataIndex: "action",
      key: "aciton",
      render: (text, row) => {
        return (
          <Space key={row._id}>
            <Tooltip title={t('edit')}>
              <Button
                title={t('edit')}
                onClick={() => onOpenModalUpdate(row)}
              >
                <EditOutlined />
              </Button>
              {/* <Button
                    danger
                  title={t('delete')}
                  onClick={() => onOpenModalDelete(row)}
                >
                  <DeleteOutlined />
                </Button> */}
            </Tooltip>
          </Space>
        );
      },
    },
  ]

  return (
    <Table loading={loading} columns={columns} dataSource={dataSource} bordered />
  );
}
